import { TriangleAlert } from 'lucide-react';

import type { GapDraftView } from '@momentum/types';

import { EvidenceList } from '../EvidenceList';

/**
 * Evidence tab — the finder's own citations, and the one dated fact behind them.
 *
 * Every note carries its `externalId` or S3 path as a badge (SPEC §4.3.3). The
 * badge is not a link: the paths point into the SharePoint mirror, which the API
 * does not serve, so a link would be a dead one.
 */
export function EvidenceTab({ draft }: { draft: GapDraftView }) {
  const { evidence, drift } = draft.source;

  return (
    <>
      <div>
        <h3 className="gr-insp-h">Evidence · {evidence.length}</h3>
        {evidence.length > 0 ? (
          <EvidenceList evidence={evidence} marker="·" tone="neutral" />
        ) : (
          <div className="gr-empty">
            <b>No citations</b>The finder recorded no evidence for this claim.
          </div>
        )}
      </div>

      <div>
        <h3 className="gr-insp-h">Drift</h3>
        <div className="gr-facts gr-facts-flush">
          <div className="gr-fact">
            <span>became flaggable</span>
            <span className="gr-fact-v mono">{drift.date}</span>
          </div>
        </div>
        <p className="gr-headline gr-stack-top-sm">{drift.reasoning}</p>
        <div className="gr-note gr-stack-top" data-tone="cyan">
          <TriangleAlert />
          <div>
            One point in time, not a timeline — which is why the escalation
            section in the reader shows a placeholder rather than rendering this
            as a history (SPEC §4.2).
          </div>
        </div>
      </div>
    </>
  );
}
